<template>
  <div class="container justify-center">
    <v-container grid-list-xs>
      <v-card width="500" class="mx-auto">
        <v-card-title primary-title>
          Deposit Cash
        </v-card-title>
        <v-card-text class="px-10">
          <v-form ref="MoneyDep">
            <v-select
              v-model.trim="cashDep.amountType"
              :items="GetCashTypes"
              :rules="[v => !!v || 'Cash Type is required']"
              label="Noca Lacagta"
              required
              no-data-text="Refresh the page"
            ></v-select>
            <v-text-field
              :rules="[v => !!v || 'Amount is require']"
              name="DepositMoney"
              label="Lacagta La dhigayo"
              id="DepositMoneyID"
              type="number"
              v-model.number="cashDep.Amount"
            ></v-text-field>
            <p
              v-if="cashDep.Amount"
              class="font-weight-black text-center black--text mt-md-5"
            >
              {{ cashDep.Amount.toLocaleString() }}
              {{ cashDep.amountType | MoneySigns }}
            </p>
            <v-text-field
              :rules="[v => !!v || 'Details is require']"
              name="DetailsDepositMoney"
              label="Faah Faahin"
              id="DetailsDepositMoneyID"
              v-model="cashDep.Details"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-10">
          <v-btn :loading="clicked" @click="OnDepMoney" color="success" block
            >Save Money</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      clicked: false,
      cashDep: {
        amountType: "",
        Details: "",
        Amount: null,
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    OnDepMoney() {
      if (this.$refs.MoneyDep.validate()) {
        this.clicked = true;
        this.cashDep.date = this.Current().date;
        this.cashDep.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/qarash/DhigidHanti",
            data: { Dhigid: this.cashDep },
          })
          .then(() => {
            this.$refs.MoneyDep.reset();
            this.clicked = false;
          })
          .catch(() => {
            // console.log(error);
            this.clicked = false;
          });
      }
    },
  },
};
</script>
